import { useState } from "react";
export default function useAsyncSelect() {
  const [optionID, setOptionID] = useState<string | null>("");
  const handleOptionSelect = (newValue: string | null) => {
    setOptionID(newValue);
  };
  return { optionID, handleOptionSelect };
}
